import { Pipe, PipeTransform } from '@angular/core';
import { ProductTypeType, ProductTypeEnum, translationKeys } from '../../../core';

@Pipe({
  name: 'declarationNodeEditorHeaderText'
})
export class DeclarationNodeEditorHeaderTextPipe implements PipeTransform {
  transform(productType: ProductTypeType = ProductTypeEnum.SUBSTANCE): string {
    switch (productType) {
      case ProductTypeEnum.COMPONENT:
        return translationKeys.productDeclaration.html.label.header.component;
      case ProductTypeEnum.SEMICOMPONENT:
        return translationKeys.productDeclaration.html.label.header.semiComponent;
      case ProductTypeEnum.MIXTURE:
        return translationKeys.productDeclaration.html.label.header.mixture;
      case ProductTypeEnum.HOMOGENEOUS_MATERIAL:
        return translationKeys.productDeclaration.html.label.header.homogeneousMaterial;
      case ProductTypeEnum.MATERIAL:
        return translationKeys.productDeclaration.html.label.header.material;
      case ProductTypeEnum.ARTICLE:
        return translationKeys.productDeclaration.html.label.header.article;
      default:
        return translationKeys.productDeclaration.html.label.header.substance;
    }
  }
}
